import { motion } from "framer-motion";
import React from "react";
import { Flex, Spacer, Text } from "@chakra-ui/react";

interface bannerProps {
  transition?: String;
}

const Banner: React.FC<bannerProps> = (props: bannerProps) => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      // y: 100,
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        // default: { duration: 2 },
      },
    },
  };

  const item = {
    hidden: { opacity: 0, x: 100, y: 0 },
    show: {
      y: 200,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };
  const slogan = {
    hidden: { opacity: 0, y: 200, x: 0 },
    show: {
      x: 100,
      opacity: 1,
      transition: { duration: 1 },
    },
  };
  // const [scale, cycle] = useCycle(3, 1);
  return (
    <Flex color="white" height="70vh" bgImage="/img/pexels.jpeg" bgSize="cover">
      <motion.div variants={container} initial="hidden" animate="show">
        <Spacer />
        <Flex direction="column">
          <Flex>
            <motion.div variants={item}>
              <Text fontSize="150px">H</Text>
            </motion.div>
            <motion.div variants={item}>
              <Text fontSize="150px">R</Text>
            </motion.div>
            <motion.div variants={item}>
              <Text fontSize="150px">B</Text>
            </motion.div>
            <motion.div variants={item}>
              <Text fontSize="150px">E</Text>
            </motion.div>
            <motion.div variants={item}>
              <Text fontSize="150px">E</Text>
            </motion.div>
          </Flex>
          <Flex>
            <motion.h5 variants={slogan} initial="hidden" animate="show">
              <Text fontSize="35px"> Passion led us here.</Text>
            </motion.h5>
          </Flex>
        </Flex>
      </motion.div>
    </Flex>
  );
};

export default Banner;
